import { entreeDossierPatient } from 'src/app/services/ressource/ressource.service';
import { Component, OnInit, AfterViewInit, ViewContainerRef, ViewChild, TemplateRef, EmbeddedViewRef } from '@angular/core';
import { Router } from '@angular/router';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MemoService } from 'src/app/services/memo/memo.service';
import { Memo } from 'src/app/utils/interfaces/new/memo.interface';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { LoginService } from 'src/app/services/login/login.service';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Subject } from 'rxjs';
import { AlarmsService } from 'src/app/services/alarms/alarms.service';
import * as moment from 'moment';
import { Alarm } from 'src/app/utils/interfaces/new/alarm.interface';
import { EventResource, SuperTypeEnum } from 'src/app/utils/interfaces/new/event-resource.interface';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { DroitsService } from 'src/app/services/droits/droits.service';
import { DestinataireAlarme } from 'src/app/utils/interfaces/new/destinataire-alarmes.interface';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { RechercheMultiService } from 'src/app/services/recherche/recherche-multi.service';
import { UserService } from 'src/app/services/user/user.service';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { FeatureKey, FeatureService, FeatureType } from 'src/app/services/feature/feature.service';
import { SnackbarService, HorizontalPositionEnum, VerticalPositionEnum} from 'src/app/services/snackbar/snackbar.service';
import { MatSnackBarRef } from '@angular/material/snack-bar';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('CourrierSnackTemplate') CourrierSnackTemplate!: TemplateRef<any>;
  snackRef!: MatSnackBarRef<EmbeddedViewRef<any>>;
  public snackProgressValue = 0;
  public durationSec = 0;
  private snackInterval: any;

  public currentUser: any;
  public usersCabinet: Destinataire[] = [];
  public listMemos: Paginated<Memo>;
  public destinataires = [];
  public startDate: string = moment(new Date()).format('YYYY-MM-DD');
  public endDate: string = moment(new Date()).format('YYYY-MM-DD');
  public listAlarms: Paginated<Alarm>;
  public localAuth: LocalAuth;
  public refreshStream: Subject<any>;
  public resource?: EventResource;
  public todayDate = '';

  public canAccessDonneesMedicales = false;

  public filtre: Filtres = {
    perpage: -1,
    currentPage: 1
  };
  public fullIconAlarm: CardIcon = {
    src: 'assets/icons/notification.svg',
    color: 'var(--orange)',
    fill: 'white'
  };

  public emptyIconMemo: CardIcon = {
    src: 'assets/icons/open-new-window.svg',
    color: 'var(--grey3)',
  };

  public fullIconMemo: CardIcon = {
    src: 'assets/icons-white/add.svg',
    color: 'var(--primary)',
  };

  public emptyIconNews: CardIcon = {
    src: 'assets/icons/open-new-window.svg',
    color: 'var(--grey3)'
  };

  public emptyIconAgenda: CardIcon = {
    src: 'assets/icons/refresh-green.svg',
    color: 'var(--primary)',
  };

  public fullIconAgenda: CardIcon = {
    src: 'assets/icons/calendar.svg',
    color: 'var(--secondary)',
    fill: 'white'
  };

  public patientVsmRechercheColumnTable = [
    { title: 'Patient', data: 'nomPrenom' },
    { title: 'Nom de naissance', data: 'nomNaissance' },
    { title: 'Nom d\'usage', data: 'nomUsage' },
    { title: 'Date de naissance', data: 'dateNaissance' },
  ];

  constructor(
    private _router: Router,
    private modalService: ModalService,
    private _viewRef: ViewContainerRef,
    private memoService: MemoService,
    private cabinetService: CabinetService,
    private loginService: LoginService,
    private alarmService: AlarmsService,
    private droitService: DroitsService,
    private _send: HeaderCommunicationService,
    private _strUtilsSrv: StringUtilsService,
    private _rechercheMulti: RechercheMultiService,
    private _utilisateur: UserService,
    private _mssSrv: MssServiceFactory,
    private _featureSrv: FeatureService,
    private _snack: SnackbarService,
  ) {
    const head: Header = {
      isHome: true,
    };
    this._send.announceHeader(head);
  }

  async ngOnInit(): Promise<void> {
    this.refreshStream = new Subject();
    this.refreshStream.subscribe(async (event) => {
      if (event === "memo") {
        this.getMemos();
      }
    })
    const getCurrentUser = this.loginService.getCurrentUser();
    this.localAuth = {
      utilisateur: getCurrentUser,
    }
    this.currentUser = this.loginService.findOneAuth(this.localAuth);
    await this.getDroitsAccessAndUpdateMenu( )

    if(this.canAccessDonneesMedicales) {
      this.usersCabinet = await this.cabinetService.findCurrentCabinetDestinataire();
      await this.getMemos();
      await this.getAlarmes();
      // await this.getCourriersReleves(); deplacement afterinit

      if (!this.resource) {
        const currentProfilStr = localStorage.getItem('currentProfil');
        const me = await this._utilisateur.me();

        if (currentProfilStr && currentProfilStr !== '') {
          const currentProfil = JSON.parse(currentProfilStr);
          if (currentProfil && currentProfil.id) {
            console.log(currentProfil);
            this.resource = {
              id: currentProfil.id,
              nom: currentProfil.qualite ? `${currentProfil.qualite} ${me.utilisateur.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(me.utilisateur.prenom)}` : `${me.utilisateur.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(me.utilisateur.prenom)}`,
              superType: SuperTypeEnum.Profil,
              responsableId: currentProfil.specialite,
              type: ''
            };
          }
        }
      }
    }

    this.todayDate = this.setTodayDate();

    if(this.canAccessDonneesMedicales) {
      const patientsVsm = await this._rechercheMulti.getPatientVsmFromRechercheMultiCrit();
      if (patientsVsm.total > 0) {
        const modal = this.modalService.openModalSelectList(
          this._viewRef,
          'Renouvellement VSM requis',
          this.patientVsmRechercheColumnTable,
          patientsVsm.objects,
          'Veuillez sélectionner un patient.');
        const sub = modal.instance.closeEmitter.subscribe(async (res: any) => {
          try {
            if (res && res.id != null) {
              console.log(res);
              this._router.navigateByUrl(`/user/patient/${res.id}`);
            }
          } finally {
            modal.destroy();
            sub.unsubscribe();
          }
        });
      }
    }

    await this._handleFeatureAccess();
  }

  ngAfterViewInit() {
    Promise.resolve().then(() => this.getCourriersReleves())
    .catch(error => {
      // gestion d’erreur globale
      console.error('Erreur au relevé des courriers', error);
    });
  }

  private async _handleFeatureAccess(): Promise<void> {
    this._featureSrv.clearCache();
    if (this.currentUser?.profil?.id) {
      const features = await this._featureSrv.getAllFeatures(FeatureType.PROFIL, this.currentUser.profil.id);
      for (const feature of features) {
        this._featureSrv.setCache(feature.key as FeatureKey, feature.value);
      }
    }
  }

  public async getCourriersReleves(): Promise<void> {
    const messagesToProcess = await this._mssSrv.getService().isThereCourriersToProcess();
    if (messagesToProcess) {
      this.snackRef = this._snack.openSnackFromTemplate(this.CourrierSnackTemplate);
      this.snackProgressValue = 0;
      const step = 100; // ms
      const durationMs = 5000; // Durée totale en ms
      this.durationSec = durationMs/1000;
      const totalSteps = durationMs / step;

      this.snackProgressValue = 0;
      let currentStep = 0;

      this.snackInterval = setInterval(() => {
        currentStep++;
        this.snackProgressValue = Math.round((currentStep / totalSteps) * 100);
        // this.cdr.detectChanges(); // <-- forcer l’update du template
        if (currentStep >= totalSteps) {
          clearInterval(this.snackInterval);
          if (this.snackRef) {
            this.snackRef.dismissWithAction(); // Valide comme si on avait cliqué sur le bouton
          }
        }
      }, step);

      this.snackRef.afterDismissed().subscribe(info => {
        clearInterval(this.snackInterval);
        this.snackProgressValue = 0;
        if (info.dismissedByAction) {
          // bouton "check" ou timeout
        } else {
          // bouton "Consulter"
          this._router.navigate(['/user/messagerie/releves']);
        }
      });
    }
  }

  public async getAlarmes() {
    this.listAlarms = await this.alarmService.find(this.filtre, { start_date: this.startDate, end_date: this.endDate });
  }

  public async getMemos() {
    this.listMemos = await this.memoService.find(this.filtre, { hide_new: false, hide_disabled: true, hide_processed: true });
  }

  public openMemo() {
    this.modalService.openModalMemo(this._viewRef, 'Mémo', this.currentUser, this.usersCabinet, 'create', this.refreshStream);
  }

  public openMemoEdit(event: Memo) {
    this.modalService.openModalMemo(this._viewRef, 'Mémo', this.currentUser, this.usersCabinet, 'edit', this.refreshStream, event);
  }

  public redirectToHypermedNews() {
    window.open('https://news.hypermed.fr');
  }

  public routeTo(routeInfo: string): void {
    this._router.navigateByUrl("/user/" + routeInfo);
  }

  public redirectToPatient(event) {
    this._router.navigateByUrl(`/patient/${event.idPatient}`);
  }

  public async disabledAlarm(event) {
    const modal = this.modalService.openModalConfirmation(this._viewRef, 'Confirmation', 'Voulez-vous vraiment masquer cette alarme ?');
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loadingModal = await this.modalService.openLoading(this._viewRef);
        try {
          let update: DestinataireAlarme;
          for (let e of event.destinataires) {
            const source = this.usersCabinet.find(x => x.id === e.idProfil);
            update = {
              idAlarme: event.id,
              idProfil: source.id,
              processed: e.processed,
              view: true,
            };
          }
          await this.alarmService.updateStatus(update);
          await this.getAlarmes();
          this.modalService.close(loadingModal);
        } catch (e) {
          this.modalService.close(loadingModal);
          console.error(e);
        }
      }
    });
  }

  private setTodayDate(): string {
    moment.locale('fr');
    const today = moment().format('dddd D MMMM');

    const todayArr = today.split(' ');
    const rtdArr = [];

    for (const w of todayArr) {
      rtdArr.push(w.charAt(0).toUpperCase() + w.slice(1));
    }
    return rtdArr.join(' ');
  }

  private async getDroitsAccessAndUpdateMenu(): Promise<void> {
    const combinatedRights = await this.droitService.findMyCombinedDroits();
    this.canAccessDonneesMedicales = combinatedRights.donneesMedicales;
  }
}
